module.exports = __webpack_public_path__ + "img/text.0b383468.png";